import React from "react";

interface AddressDisplayProps {
  address1: string;
  address2?: string;
  city: string;
  state: string;
  zipCode: string;
}

export default function AddressDisplay({
  address1,
  address2,
  city,
  state,
  zipCode,
}: AddressDisplayProps) {
  return (
    <div>
      <div>
        {address1}
        {!!address2 && ", "}
        {address2}
      </div>
      <div>
        {city}, {state} {zipCode}
      </div>
    </div>
  );
}
